// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ai-chat-container[data-v-5e2f4340]{position:relative;z-index:9999}.ai-chat-button[data-v-5e2f4340]{position:fixed;transition:transform .3s ease;z-index:9999}.message-text[data-v-5e2f4340]{word-wrap:break-word;white-space:pre-wrap}.message-time[data-v-5e2f4340]{font-size:.8em;color:#999;margin-top:4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
